import React from 'react';
import { BaseModal } from 'src/design/molecules/BaseModal';
import { ClientGpDto, ContactDto } from 'src/api/FiretrolApiClient';
import { CreateContactForm } from './CreateContactForm';

interface CreateContactDialogProps {
  open: boolean;
  onClose: () => void;
  contact: ContactDto | null;
  clientOptions?: ClientGpDto[];
}

export const CreateContactDialog: React.FC<CreateContactDialogProps> = ({
  open,
  onClose,
  contact,
  clientOptions,
}) => {
  return (
    <BaseModal
      opened={open}
      onClose={onClose}
      title={contact ? 'Update Contact' : 'Create New Contact'}
      size="xl"
      centered
    >
      <CreateContactForm
        setCreateContactDialogOpen={onClose}
        selectedContact={contact}
        clientOptions={clientOptions}
      />
    </BaseModal>
  );
};
